<template>
<div class="authsDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' :title="'批量审核'" :visible.sync="dialogVisible" width="600px">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm form">
            <el-form-item label="设置团长佣金（%）" prop="headerrate" class="content">
                <el-input v-model.trim="item.headerrate" placeholder="请输入团长佣金" min="0" max="100" clearable></el-input>
            </el-form-item>
            <el-form-item label="设置推荐团长佣金（%）" prop="recommendrate" class="content">
                <el-input v-model.trim="item.recommendrate" placeholder="请输入推荐团长佣金" clearable></el-input>
            </el-form-item>
            <el-form-item class="form-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import {uploadHostHeaderAuditInfoBybatch}  from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'authsDialog',
    data() {
        let validateHeaderrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        let validateRecommendrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('推荐团长佣金团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            item: {
                headerinnerid: '',
                headerrate: '',
                hostroletype: 2,
                recommendrate: '',
                ppid: '',
                result: 1
            },
            rules: {
                headerrate: [
                    {required: true, message: '请输入提团长佣金', trigger: 'blur'},
                    {pattern: /^(0|[1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateHeaderrate, trigger: 'blur'},
                ],
                recommendrate: [
                    {required: true, message: '请输入推荐团长佣金', trigger: 'blur'},
                    {pattern: /^(0|[1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的推荐团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateRecommendrate, trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.item.headerinnerid = row.headerinnerid
            this.item.headerrate = row.brokeragerateheader
            this.item.recommendrate = row.brokerageraterecommend
            this.dialogVisible = true
        },
        cancel() {
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认批量审核', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            uploadHostHeaderAuditInfoBybatch({
                data: Object.assign({}, this.item),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('佣金比例设置成功')
                    this.$emit('getList')
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([ 'user', 'params', 'brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.authsDialog {
}
</style>
